
const features = [
  'Licensed and Insured Professionals',
  'Over 15 Years of Experience',
  'Quality Materials and Workmanship',
  'Competitive Pricing',
  'Customer Satisfaction Guaranteed',
  'Free Estimates and Consultations'
];

const stats = [
  { number: '100+', label: 'Projects Completed' },
  { number: '15+', label: 'Years of Experience' },
  { number: '100%', label: 'Satisfaction Guaranteed' }
];

export default function About() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-blue-600 font-semibold text-lg mb-4 uppercase tracking-wide">
              About Us
            </p>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Looking to reduce energy costs and protect your home?
            </h2>
            
            <p className="text-lg text-gray-600 mb-6">
              At Shadowfax Roofing and Solar, we combine decades of roofing expertise with 
              cutting-edge solar technology to deliver comprehensive solutions for your home.
            </p>
            
            <p className="text-lg text-gray-600 mb-8">
              Our commitment to integrity means transparent pricing, honest assessments, and 
              quality work that stands the test of time. We don't just install roofs and solar 
              panels—we build lasting relationships with our clients.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-gray-800 rounded-2xl p-8 shadow-xl">
              <div className="space-y-6">
                {stats.map((stat, index) => (
                  <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                    <h3 className="text-3xl font-bold text-white mb-2">{stat.number}</h3>
                    <p className="text-gray-200">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-200 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-blue-100 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
